module.exports = __webpack_public_path__ + "img/sample_main_title.9333a783.png";